import script from "./TheButton.vue?vue&type=script&setup=true&lang=js"
export * from "./TheButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__